module.exports = __webpack_public_path__ + "static/media/usa.583b3189.svg";